import React from 'react';
import memoize from 'memoize-one';
import ActionsGroup from './ActionsGroup';

const ColumnsGroup = memoize((clickHandler = () => {}) => [
  {
    name: 'Nombre del grupo',
    selector: 'name',
    sortable: true
  },
  {
    name: 'Total Trabajadores',
    selector: 'total_employees',
    sortable: true,
    center: true
  },
  {
    name: 'Causal de término de contrato',
    selector: 'termination_reason',
    sortable: false
  },
  {
    name: 'Fecha de Término',
    selector: 'parsed_end_date',
    sortable: false
  },
  {
    name: 'Simulación',
    selector: 'simulation',
    sortable: false,
    center: true
  },
  {
    name: 'Total Finiquitos',
    selector: 'parsed_total_amount',
    center: true
  },
  {
    name: 'Acciones',
    cell: item => <ActionsGroup item={item} handleClick={clickHandler} />,
    ignoreRowClick: true,
    center: true,
    button: true,
    minWidth: '140px'
  }
]);

export default ColumnsGroup;
